import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from './Button';
import Icon from '../AppIcon';

const QuickActionButton = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const getContextualActions = () => {
    const currentPath = location?.pathname;
    
    switch (currentPath) {
      case '/dashboard':
        return [
          {
            label: 'Nova Pelada',
            icon: 'Plus',
            action: () => navigate('/match-details'),
            color: 'bg-primary hover:bg-primary/90'
          },
          {
            label: 'Buscar Quadra',
            icon: 'MapPin',
            action: () => navigate('/venue-search'),
            color: 'bg-secondary hover:bg-secondary/90'
          },
          {
            label: 'Planejar Churrasco',
            icon: 'Utensils',
            action: () => navigate('/barbecue-planning'),
            color: 'bg-accent hover:bg-accent/90'
          }
        ];
      
      case '/venue-search':
        return [
          {
            label: 'Reservar Quadra',
            icon: 'Calendar',
            action: () => handleVenueBooking(),
            color: 'bg-primary hover:bg-primary/90'
          },
          {
            label: 'Filtros',
            icon: 'Filter',
            action: () => handleFilters(),
            color: 'bg-secondary hover:bg-secondary/90'
          }
        ];
      
      case '/barbecue-planning':
        return [
          {
            label: 'Adicionar Item',
            icon: 'Plus',
            action: () => handleAddItem(),
            color: 'bg-primary hover:bg-primary/90'
          },
          {
            label: 'Convidar Amigos',
            icon: 'UserPlus',
            action: () => handleInviteFriends(),
            color: 'bg-secondary hover:bg-secondary/90'
          }
        ];
      
      default:
        return [
          {
            label: 'Nova Pelada',
            icon: 'Plus',
            action: () => navigate('/match-details'),
            color: 'bg-primary hover:bg-primary/90'
          }
        ];
    }
  };

  const handleVenueBooking = () => {
    // Simulate venue booking action
    console.log('Booking venue...');
    setIsExpanded(false);
  };

  const handleFilters = () => {
    // Simulate filters action
    console.log('Opening filters...');
    setIsExpanded(false);
  };

  const handleAddItem = () => {
    // Simulate add item action
    console.log('Adding item to barbecue list...');
    setIsExpanded(false);
  };

  const handleInviteFriends = () => {
    // Simulate invite friends action
    console.log('Inviting friends...');
    setIsExpanded(false);
  };

  const actions = getContextualActions();
  const primaryAction = actions?.[0];

  const handlePrimaryAction = () => {
    if (actions?.length === 1) {
      primaryAction?.action();
    } else {
      setIsExpanded(!isExpanded);
    }
  };

  const handleActionClick = (action) => {
    action?.action();
    setIsExpanded(false);
  };

  return (
    <>
      {/* Overlay */}
      {isExpanded && (
        <div 
          className="fixed inset-0 bg-black/20 z-40"
          onClick={() => setIsExpanded(false)}
        />
      )}
      {/* Quick Action Button */}
      <div className="fixed bottom-6 right-6 z-50">
        {/* Expanded Actions */}
        {isExpanded && actions?.length > 1 && (
          <div className="absolute bottom-16 right-0 space-y-3 animate-slide-up">
            {actions?.slice(1)?.reverse()?.map((action, index) => (
              <div
                key={index}
                className="flex items-center space-x-3"
              >
                <span className="bg-card text-card-foreground px-3 py-2 rounded-lg shadow-elevation-2 text-sm font-medium whitespace-nowrap">
                  {action?.label}
                </span>
                <button
                  onClick={() => handleActionClick(action)}
                  className={`w-12 h-12 rounded-full ${action?.color} text-white shadow-elevation-3 flex items-center justify-center transition-spring hover-scale`}
                >
                  <Icon name={action?.icon} size={20} />
                </button>
              </div>
            ))}
          </div>
        )}

        {/* Primary Action Button */}
        <button
          onClick={handlePrimaryAction}
          className={`w-14 h-14 rounded-full ${primaryAction?.color} text-white shadow-elevation-4 flex items-center justify-center transition-spring hover-scale relative`}
        >
          <Icon 
            name={actions?.length > 1 ? (isExpanded ? 'X' : primaryAction?.icon) : primaryAction?.icon} 
            size={24} 
          />
          
          {/* Ripple effect on tap */}
          <div className="absolute inset-0 rounded-full bg-white/20 scale-0 transition-transform duration-200 pointer-events-none" />
        </button>

        {/* Action indicator for multiple actions */}
        {actions?.length > 1 && !isExpanded && (
          <div className="absolute -top-1 -right-1 w-6 h-6 bg-accent text-accent-foreground rounded-full flex items-center justify-center text-xs font-bold shadow-elevation-2">
            {actions?.length}
          </div>
        )}
      </div>
    </>
  );
};

export default QuickActionButton;